import AMLFire from './AMLFire';

export default AMLFire;
